<script setup>
import { useI18n } from 'vue-i18n';
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useAccount } from 'dashboard/composables/useAccount';

import BaseSettingsHeader from '../components/BaseSettingsHeader.vue';
import SettingsLayout from '../SettingsLayout.vue';
import ConfigIndex from './ConfigIndex.vue';
import RoomsIndex from './RoomsIndex.vue';
import RatesIndex from './RatesIndex.vue';
import ExtrasIndex from './ExtrasIndex.vue';
import RoomRatesIndex from './RoomRatesIndex.vue';
import BookingsIndex from './BookingsIndex.vue';
import CalendarIndex from './CalendarIndex.vue';

const props = defineProps({
  activeTab: {
    type: String,
    default: 'config',
  },
});

const { t } = useI18n();
const route = useRoute();
const { accountScopedRoute } = useAccount();

const tabs = computed(() => [
  {
    key: 'config',
    label: t('MOTOR_RESERVA.TABS.CONFIG'),
    routeName: 'motor_reserva_config',
  },
  {
    key: 'rooms',
    label: t('MOTOR_RESERVA.TABS.ROOMS'),
    routeName: 'motor_reserva_rooms',
  },
  {
    key: 'rates',
    label: t('MOTOR_RESERVA.TABS.RATES'),
    routeName: 'motor_reserva_rates',
  },
  {
    key: 'extras',
    label: t('MOTOR_RESERVA.TABS.EXTRAS'),
    routeName: 'motor_reserva_extras',
  },
  {
    key: 'room-rates',
    label: t('MOTOR_RESERVA.TABS.ROOM_RATES'),
    routeName: 'motor_reserva_room_rates',
  },
  {
    key: 'calendar',
    label: 'Calendário',
    routeName: 'motor_reserva_calendar',
  },
  {
    key: 'bookings',
    label: t('MOTOR_RESERVA.TABS.BOOKINGS'),
    routeName: 'motor_reserva_bookings',
  },
]);

const componentMap = {
  config: ConfigIndex,
  rooms: RoomsIndex,
  rates: RatesIndex,
  extras: ExtrasIndex,
  'room-rates': RoomRatesIndex,
  calendar: CalendarIndex,
  bookings: BookingsIndex,
};

const currentComponent = computed(
  () => componentMap[props.activeTab] || ConfigIndex
);
</script>

<template>
  <SettingsLayout>
    <template #header>
      <BaseSettingsHeader :title="t('MOTOR_RESERVA.HEADER')" description="" />
    </template>
    <template #default>
      <div class="flex flex-col gap-4">
        <div class="flex gap-1 border-b border-slate-100 dark:border-slate-700">
          <router-link
            v-for="tab in tabs"
            :key="tab.key"
            :to="accountScopedRoute(tab.routeName)"
            class="px-4 py-2 text-sm font-medium transition-colors border-b-2 -mb-px"
            :class="
              activeTab === tab.key
                ? 'border-woot-500 text-woot-500'
                : 'border-transparent text-slate-600 dark:text-slate-300 hover:text-woot-500 hover:border-slate-300'
            "
          >
            {{ tab.label }}
          </router-link>
        </div>
        <component :is="currentComponent" />
      </div>
    </template>
  </SettingsLayout>
</template>
